import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import './styles/global.css';

const el = document.getElementById('root');
if (!el) throw new Error('root element missing');

createRoot(el).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
